import {
  erroreCampoObbligatorio,
  formEditReportedAnswer,
  inputDescription,
  panelLabelAnswerAI,
  panelLabelQuestion,
  snackbarReportResolvedSubTitlePartiallyWarning,
  snackbarReportResolvedTitle,
} from "_constants";
import { DetailRepliedAnswer } from "components/shared";
import { useConfirmDialogExit } from "hooks";
import { Report, UpdateStatusReportPartiallyWrongRequest } from "interfaces";
import { Divider } from "primereact/divider";
import { InputTextarea } from "primereact/inputtextarea";
import { DetailPanelContext } from "providers/DetailPanelProvider";
import { useSnackbar } from "providers/SnackbarProvider";
import { useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { updateStatusReportPartiallyWrong } from "services";
import { setCheckOpenedReportLoadStatus } from "store/slicer/CheckOpenedReportSlice";
import { setPageReports } from "store/slicer/GestioneReportSlice";
import { useAppDispatch } from "store/store";

export const ModalResolveReportPartiallyWrongBodyRight = ({
  report,
  onClose,
}: {
  report: Report;
  onClose: Function;
}) => {
  const dispatch = useAppDispatch();
  const { hidePanel } = useContext(DetailPanelContext);
  const { showConfirmUpdateStatusReport } = useConfirmDialogExit();
  const { showSnackbar } = useSnackbar();
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      id: "",
      message: "",
    },
    shouldFocusError: false,
    mode: "onChange",
  });

  useEffect(() => {
    setValue("id", report.id);
    setValue("message", report.answer?.message ?? "");
    setTimeout(() => {
      document.getElementById("message")?.focus();
    }, 100);
  }, [report, setValue]);

  const confirmUpdateStatusReport = (
    formData: UpdateStatusReportPartiallyWrongRequest
  ) => {
    updateStatusReportPartiallyWrong(formData)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarReportResolvedTitle,
          detail: snackbarReportResolvedSubTitlePartiallyWarning,
          life: 5000,
        });
        dispatch(setPageReports(-1));
        setTimeout(() => {
          dispatch(setPageReports(1));
        }, 200);
        dispatch(setCheckOpenedReportLoadStatus(false));
        onClose();
        hidePanel();
      })
      .catch((_) => {});
  };

  const onSubmit = (formData: UpdateStatusReportPartiallyWrongRequest) => {
    showConfirmUpdateStatusReport({
      callback: () => confirmUpdateStatusReport(formData),
    });
  };

  return (
    <div className="padd-left-18 padd-right-18 modal-resolve-detail-container">
      <div className="question-container margin-top-18">
        <span className="blue-text font-weight-700 margin-bottom-8">
          {panelLabelQuestion}
        </span>
        {report.answer?.repliedAnswer && (
          <DetailRepliedAnswer
            repliedAnswer={report.answer?.repliedAnswer}
            className="padd-top-18 padd-bottom-18"
          />
        )}
        <div className="question-container-value margin-top-8 blue-500">
          {report.answer?.question}
        </div>
        <Divider className="question-divider margin-top-26 margin-bottom-26" />
      </div>
      <div className="answer-container">
        <span className="blue-text font-weight-700 margin-bottom-8">
          {panelLabelAnswerAI}
        </span>

        <div className="margin-top-8">
          <form
            id={formEditReportedAnswer}
            onSubmit={handleSubmit(onSubmit)}
            className="width-100"
          >
            <Controller
              name="message"
              control={control}
              rules={{ required: erroreCampoObbligatorio }}
              render={({ field, fieldState: { error } }) => {
                return (
                  <div className="flex-container column">
                    <InputTextarea
                      autoResize={true}
                      id={field.name}
                      {...field}
                      className={`width-100 ${
                        error ? "p-invalid margin-bottom-4" : ""
                      }`}
                      placeholder={inputDescription}
                      rows={5}
                    />
                    {error && (
                      <small className="p-error margin-bottom-4">
                        {error.message}
                      </small>
                    )}
                  </div>
                );
              }}
            />
          </form>
        </div>
      </div>
    </div>
  );
};
